// extracted by mini-css-extract-plugin
export var copyableField = "_jn-4";
export var customerBadge = "_jn-0";
export var customerInfoTitle = "_jn-2";
export var details = "_jn-1";
export var dropdownContainer = "_jn-5";
export var dropdownImage = "_jn-6";
export var editAssigneeForm = "_jn-a";
export var editButton = "_jn-3";
export var email = "_jn-7";
export var hidden = "_jn-d";
export var input = "_jn-8";
export var saveButton = "_jn-b";
export var shopifyIcon = "_jn-c";
export var suggestionBadge = "_jn-e";
export var suggestionText = "_jn-f";
export var username = "_jn-9";